import { api } from "./api";

const PENDING_SIGNUP_KEY = "chuzi.auth.pendingSignup";

export type PendingSignup = {
  email: string;
  username: string;
};

export function getPendingSignup(): PendingSignup | null {
  try {
    const raw = localStorage.getItem(PENDING_SIGNUP_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingSignup;
    if (!parsed.email || !parsed.username) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setPendingSignup(value: PendingSignup) {
  try {
    localStorage.setItem(PENDING_SIGNUP_KEY, JSON.stringify(value));
  } catch {
    // Storage may be unavailable; signup still proceeds.
  }
}

export function clearPendingSignup() {
  try {
    localStorage.removeItem(PENDING_SIGNUP_KEY);
  } catch {
    // ignore
  }
}

export async function applyPendingSignupIfNeeded(email: string) {
  const pending = getPendingSignup();
  if (!pending) return;
  if (pending.email.toLowerCase() !== email.toLowerCase()) return;

  let usernameToPersist = pending.username.trim();
  if (!usernameToPersist) {
    clearPendingSignup();
    return;
  }

  const availability = await api.auth.usernameAvailability(usernameToPersist);
  if (!availability.available) {
    usernameToPersist = (availability.suggestion ?? `${usernameToPersist}x`).trim();
  }
  await api.user.updateProfile({ username: usernameToPersist });

  clearPendingSignup();
}
